

const NavItem = ({handleItemClick,clickedItem,children,itemIndex,className}) => {
  return (
    <li  className={`rounded-[20px] my-3 ${clickedItem === 3 ? "hidden md:inline-flex":"inline-flex"}  hover:text-[#efefefc8]   md:my-0 md:p-2 ${itemIndex !== 4 ? "hover:md:text-black":""}   hover:md:bg-white transition-colors duration-150 md:py-4 md:px-6 lg:py-5 lg:px-11 ${className}  ${clickedItem === itemIndex ? 'md:border-[#8C72F4]  ' : ''}`} onMouseEnter={() => handleItemClick(itemIndex)}  onClick={() => handleItemClick(itemIndex)}>{children}</li>

  )
}

export default NavItem